import { ref } from 'vue'
import { functions, httpsCallable } from '@/firebase/config'

// add admin cloud function
const error = ref(null)
const listOfUsers = ref(null)
const teachers = ref(null)
const learners = ref(null)
const admins = ref(null)

const fetchListOfUsers = async () => {
  error.value = null
  const fetchUsers = httpsCallable(functions, 'fetchUsers')

  fetchUsers().then(result => {
    // console.log(result.data)
    // include a school token to specify which school the credential belongs to
    listOfUsers.value = result.data
    const filteredTeachers = result.data.filter(record => record.role === 'teacher')
      .filter(record => record.email.substr(record.email.length - 17) === 'inspireschool.com')
    const filteredLearners = result.data.filter(record => record.role === 'learner')
      .filter(record => record.email.substr(record.email.length - 17) === 'inspireschool.com')
    const filteredAdmins = result.data.filter(record => record.role === 'testAdmin')
    const vitoweSchools = filteredAdmins
      .filter(record => record.email.substr(record.email.length - 17) === 'inspireschool.com')
    admins.value = vitoweSchools.map((record, index) => ({ ...record, rank: index + 1 }))
    teachers.value = filteredTeachers.map((record, index) => ({ ...record, rank: index + 1 }))
    learners.value = filteredLearners
  }).catch((error) => {
    // Getting the Error details.
    const code = error.code
    const message = error.message
    const details = error.details
    error.value = code + message + details
    // ...
  })
}
// Call updateUser.js
const getListOfUsers = () => {
  return { error, listOfUsers, teachers, learners, admins, fetchListOfUsers }
}

export default getListOfUsers
